var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"info"}},[(_vm.visible)?_c('div',{staticClass:"info",style:({'zIndex': 2000 + _vm.seed})},[_vm._v(_vm._s(_vm.message))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.2@vue-loader/lib/template-compiler?{"id":"data-v-111ab27b","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.2@vue-loader/lib/selector.js?type=template&index=0!./src/lib/info/main.vue
// module id = 30
// module chunks = 0